import React from 'react';
import { Card, CardContent } from '../ui/card';

const SkeletonSector = () => (
  <Card className="group hover:shadow-2xl transition-all duration-300">
    <CardContent className="p-8">
      {/* Icon skeleton */}
      <div className="w-16 h-16 bg-gray-200 rounded-full mb-6 animate-pulse" />
      
      {/* Title skeleton */}
      <div className="h-7 bg-gray-200 rounded w-3/4 mb-4 animate-pulse" />
      
      {/* Description skeleton */}
      <div className="space-y-2 mb-6">
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse" />
        <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse" />
      </div>
      
      {/* Practice areas skeleton */}
      <div className="space-y-3 mb-6">
        <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse" />
        <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse" />
        <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse" />
      </div>
      
      {/* Badge skeleton */}
      <div className="h-6 bg-gray-200 rounded-full w-24 animate-pulse" />
    </CardContent>
  </Card>
);

export const SectorsSkeletonLoader = () => (
  <div className="min-h-screen pt-20 bg-gray-50">
    {/* Hero skeleton */}
    <section className="relative py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="h-12 bg-gray-700 rounded w-2/3 mx-auto mb-6 animate-pulse" />
          <div className="h-6 bg-gray-700 rounded w-1/2 mx-auto animate-pulse" />
        </div>
      </div>
    </section>

    {/* Content skeleton */}
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[...Array(6)].map((_, i) => (
            <SkeletonSector key={i} />
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default SectorsSkeletonLoader;
